import { useState, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { currentUser } = useAuth();

  const request = useCallback(async (url, options = {}) => {
    setLoading(true);
    setError(null);
    try {
      const headers = { ...options.headers };
      if (currentUser) {
        const token = await currentUser.getIdToken();
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await fetch(url, { ...options, headers });

      if (!response.ok) {
        let errorDetail = response.statusText;
        try {
          const errData = await response.json();
          errorDetail = errData.detail || JSON.stringify(errData);
        } catch (e) {
          // Ignore if response body is not JSON
        }
        const errorObj = new Error(errorDetail);
        errorObj.status = response.status;
        throw errorObj;
      }
      return await response.json();
    } catch (err) {
      setError({
        message: err.message,
        status: err.status
      });
      throw err;
    } finally {
      setLoading(false);
    }
  }, [currentUser]);

  const clearError = useCallback(() => setError(null), []);

  return { loading, error, request, clearError };
};